const UPDATE_CATERING_SETTINGS = (state, { settings, error = null }) => {
  state.catering.settings = { ...state.catering.settings, settings, error };
};

const UPDATE_CATERING_USERS = (state, users) => {
  state.users = users;
};

const UPDATE_LOCAL_PINCODE = (state, { code }) => {
  state.catering = { ...state.catering, pinCode: code };
};

const UPDATE_CATERING_DATA = (state, data) => {
  state.catering.data = data;
};

export default {
  UPDATE_CATERING_SETTINGS,
  UPDATE_CATERING_USERS,
  UPDATE_LOCAL_PINCODE,
  UPDATE_CATERING_DATA,
};



// WEBPACK FOOTER //
// ./store/modules/catering/mutations.js